$shm_hitalama_text_code $mol_text_code
	render_visible_only false
	Rows $shm_hitalama_text_rows
		render_visible_only <= render_visible_only
		rows <= rows
	sub /
		<= Rows
		<= Copy_button $shm_button_copy
			text <= text_export
